import React from "react";

export const recommended_points = (type, comment) => {
  if(comment){
    return (
      <div className="recommended_points">
        <div className="detail" dangerouslySetInnerHTML={{ __html: comment }} />
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./pages/detail/recommended_points.jsx